var ENecctonNotificationType = /* @__PURE__ */ ((ENecctonNotificationType2) => {
  ENecctonNotificationType2["amountLostDay"] = "neccton-amount-lost-day";
  ENecctonNotificationType2["amountDepositDay"] = "neccton-amount-deposit-day";
  ENecctonNotificationType2["depositFrequencyDay"] = "neccton-deposit-frequency-day";
  ENecctonNotificationType2["longSessionLength"] = "neccton-long-session-length";
  return ENecctonNotificationType2;
})(ENecctonNotificationType || {});
export {
  ENecctonNotificationType
};
